export default __webpack_public_path__ + "img/28.ae6f4062.jpg";